<div class="dialog-container">
    <div class="dialog-title-block">
        <h2 class="text-capitalize">User Details</h2>
        <div class="flex-container">
            <div class="dialog-btn" (click)="onClose()">
                <img class="dialog-colse-btn" src="../../../assets/images/close.png" alt="close">
            </div>
        </div>
    </div>
    <div class="dialog-content-block p-3">
        <div class="app-border-grey">
            <div class="flex-container gap-3 p-3 justify-content-between app-border-grey--bottom">
                <div class="flex-container gap-3">
                    <div>
                        <h2 class="text-heading-3 mb-2 text-capitalize">{{ userDetails?.first_name }} {{ userDetails?.last_name }}</h2>
                        <h6 class="text-heading-6 fw-normal text-grey text-capitalize">Added by {{ userDetails?.added_by.first_name + " " + userDetails?.added_by.last_name}}</h6>
                    </div>
                </div>
                <div class="align-self-start">
                    <img class="me-3 cursor-pointer" src="../../../assets/images/edit.svg" alt="" srcset="" (click)="editUserDialog()">
                    <img class="cursor-pointer" src="../../../assets/images/trash.svg" alt="" srcset="">
                    <!-- <h6 class="text-heading-6 fw-semibold text-grey">Status</h6> -->
                </div>
            </div>
            <div class="d-flex flex-column gap-3 w-100 p-3">
                <div class="d-flex align-items-start">
                    <h6 class="user-label text-para text-grey-100">Username</h6>
                    <h6 class="user-data text-para text-dark">{{ userDetails?.username }}</h6>
                </div>
                <div class="d-flex align-items-start">
                    <h6 class="user-label text-start text-para text-grey-100">Email</h6>
                    <h6 class="user-data text-start text-para text-dark">{{ userDetails?.email }}</h6>
                </div>
                <div class="d-flex align-items-start">
                    <h6 class="user-label text-start text-para text-grey-100">Role</h6>
                    <a class="user-data cursor-pointer text-start text-link text-primary text-decoration-underline text-capitalize" (click)="navigateToRole(userDetails?.roles[0].id)">{{ userDetails?.roles[0].name }}</a>
                </div>
                <div class="d-flex align-items-start">
                    <h6 class="user-label text-para text-grey-100">Assigned Stores</h6>
                    <h6 class="user-data text-start text-para text-dark" *ngIf="userDetails?.stores.length === 0">-</h6>
                    <div 
                        *ngIf="userDetails?.stores.length !== 0"
                        class="user-data d-flex flex-wrap gap-2 align-items-center"
                    >
                        <p class="bg-grey-300 text-para text-dark rounded-pill px-3 py-1" *ngFor="let store of userDetails?.stores">{{ store.name }}</p>
                    </div>
                </div>
                <div class="d-flex align-items-start">
                    <h6 class="user-label text-start text-para text-grey-100">Added Date</h6>
                    <h6 class="user-data text-start text-para text-dark">{{ timestampFormat(userDetails?.created_at, "DD/MM/YYYY") }}</h6>
                </div>
                <div class="d-flex align-items-start">
                    <h6 class="user-label text-start text-para text-grey-100">Contact Number</h6>
                    <h6 class="user-data text-start text-para text-dark">{{ userDetails?.contact_number ? userDetails?.contact_number : '-' }}</h6>
                </div>
            </div>
        </div>
    </div>
</div>



